import { CheckOutlined } from '@ant-design/icons';
import { Button, Radio, Rate, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { VendorItemPriceStatuses } from '../../../library/constants/VendorItemPriceStatuses.js';
import { ERP_CURRENCY } from '../../../library/constants/dynamic.js';
import { formatNumber, formatPrice } from '../../../library/utilities/intl.js';
import SmallSection from '../../design/small-section.jsx';
import styles from './project-item-vendor-prices.module.scss';

const ProjectItemVendorPrices = ({ data, isFinisher, active, onVendorChange }) => {
    const prices = Array.isArray(data.prices) ? data.prices : []
    const pricesGridClassName = isFinisher === 1 ? styles.quantityPricesHeadVat : styles.quantityPricesHead
    const quantityPriceGridClassName = isFinisher === 1 ? styles.vendorQuantityPriceVat : styles.vendorQuantityPrice

    return <div key={data.id} className={styles.vendor}>
        <div className={styles.vendorHeader}>
            <div className={styles.vendorSelect}>
                {onVendorChange && <Radio checked={data.isSelected} onChange={() => onVendorChange(data.id)} />}
            </div>
            <div className="">
                <div className={styles.vendorName}>
                    {data.company}
                </div>
                <div className={styles.vendorRating}>
                    <Rate defaultValue={data?.rating} disabled />
                </div>
            </div>
            <div className={styles.vendorActions}>
                {(data.status === VendorItemPriceStatuses.USED_FOR_QUOTATION) && (
                    <Tooltip title="Selected for quotation">
                        <Button icon={<CheckOutlined />} shape="square" type="primary" />
                    </Tooltip>
                )}
                {(data.status === VendorItemPriceStatuses.SELECTED_FOR_PRODUCTION) && (
                    <Tooltip title="Selected for Production">
                        <Button icon={<CheckOutlined />} shape="square" type="primary" />
                    </Tooltip>
                )}
                {/* <Tooltip title="Expected Delivery Date by Vendor">
                    <Button shape="square" type="default" className="ant-btn-actionpanel" ghost>24-01-2023</Button>
                </Tooltip> */}
            </div>
        </div>
        <div className={styles.vendorPrices}>
            <div className={pricesGridClassName}>
                <div>Quantity</div>
                <div>Purchase Price</div>
                {isFinisher === 1 && <div>Finisher&apos;s Price</div>}
                <div>Handling Charges</div>
                <div>Shipping Charges</div>
                <div>Margin</div>
                <div>Sales Price</div>
                <div>Total Price</div>
                <div>Total Price (Incl. VAT)</div>
            </div>
            {prices.map((price) => (
                <SmallSection key={price.quantity} colorLight="#fff2e9" colorDark="#fe7b1c" containerStyles={{ opacity: (active === 1 && price.status === 1) ? 0.6 : 1 }}>
                    <div className={quantityPriceGridClassName}>
                        <div>{price.quantity}</div>
                        <div>{formatPrice(price.purchase_price, ERP_CURRENCY)}</div>
                        {isFinisher === 1 && (<div>{formatPrice(price.finisher_price, ERP_CURRENCY)}</div>)}
                        <div>{formatPrice(price.handling_charge, ERP_CURRENCY)}</div>
                        <div>{formatPrice(price.shipping_charge, ERP_CURRENCY)}</div>
                        <div>{formatNumber(price.margin)}%</div>
                        <div>{formatPrice(price.sales_price, ERP_CURRENCY)}</div>
                        <div>{formatPrice(price.total_price, ERP_CURRENCY)}</div>
                        <div>{formatPrice(price.total_price_incl_vat, ERP_CURRENCY)}</div>
                    </div>
                </SmallSection>
            ))}
        </div>
    </div>;
}

ProjectItemVendorPrices.propTypes = {
    data: PropTypes.object.isRequired,
    active: PropTypes.number,
    onVendorChange: PropTypes.func,
    isFinisher: PropTypes.number,
}

export default ProjectItemVendorPrices
